import React, { useState, useEffect, useRef, useCallback } from "react";
import styled from "styled-components";
import "turn.js";
import { useSwipeable, Swipeable } from "react-swipeable";

import Thumbnail from "./../Thumbnail";
import { useEventListener, useWindowSize } from "./../../hooks";

import { thumbdata, chevronsrc, paneltogglesrc } from "./../../constants";
import { useMount } from "react-use";

const Chevron = styled.img`
    transition: bottom 0.25s ease-in-out, opacity 0.25s, transform 0.25s !important ;
    ${(props) => (!props.showThumbs ? "transform:translateX(-50%) rotate(180deg) !important;" : "")}
`;

const Wrapper = styled.div`
    position: ${props => props.isedge?"fixed":"absolute"};
    width: 100%;
    height: 120px;
    bottom: 0;
    overflow:hidden;
    ${(props) => (props.show ? "" : "height:0;")}
    transition: height 0.25s ease-in-out;

    @keyframes bottomtrans{
        0%{
            bottom: 0;
        }
        90%{
            display: block;
            opacity: 1;
        }
        100%{
            bottom: -120px;
            display: none;
            opacity: 1;
        }
    }

    & .scrollWrapper{
        ${(props) => (props.show ? "bottom:0;" : "bottom:-120px;")}
        transition: bottom 0.25s ease-in-out;
    }
    & .navigator {
        border-radius: 50%;
        background: #b4b9cb;
        position: absolute;
        top: 50%;
        z-index: 5;
        ${(props) => (props.show ? "opacity:1" : "opacity:0;")}
        transition: opacity 0.1s ease-in-out;
        &:hover {
            box-shadow: 0 0 10px #666;
        }
    }

    & .navigator.left {
        left: 5%;
        transform: translate(-120%, -50%);
    }
    & .navigator.right {
        right: 5%;
        transform: translate(120%, -50%);
    }

    & .togglePanel {
        width: 32px;
        z-index: 5;
        left: 50%;
        transform: translateX(-50%);
        position: fixed;
        ${(props) => (props.show ? "bottom: 110px;" : "bottom: 10px;")}
        border-radius: 50%;
        background: #b4b9cb;
        opacity: 0.4;
        transition: bottom 0.25s ease-in-out, opacity 0.25s;

        &:hover {
            opacity: 0.9;
        }
    }
`;

const ScrollWrapper = styled.div`
    position: absolute;
    height: 120px;
    bottom: 0;
    width: 90%;
    left: 5%;
    overflow: auto;
    overflow: -moz-scrollbars-none;
    max-width: calc(100% - 48px - 2rem);
    left: 50%;
    transform: translateX(-50%);
    ::-webkit-scrollbar {
        width: 0px;
    }
    -ms-overflow-style: none;
`;

const TightWrapper = styled.div`
    width: auto;
    height: 63px;
    display: inline-flex;
    white-space: nowrap;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    ${(props) => (!props.isOverflow ? "left: 50%;transform: translate(-50%, -50%);" : "")}
`;
let hiddenOnce;
const ThumbsWrapper = (props) => {
    const { activePage, triggerPage, showToast, clickAudioHandler,page } = props;
    const [activeThumb, setactiveThumb] = useState(-1);
    const [isOverflow, setisOverflow] = useState(false);
    const [showThumbs, setshowThumbs] = useState(true);
    const scrolldiv = useRef(null);
    const windowsize = useWindowSize();

    const isedge = window.navigator.userAgent.indexOf("Edge") > -1;

    // console.log("isedge", isedge);

    useEffect(() => {
        if (showToast === false && !hiddenOnce)
            setTimeout(() => {
                hiddenOnce = true;
                setshowThumbs(false);
            }, 3000);
    }, [showToast]);
    const handleSwipe = (e) => {
        let i = 0;
        const loop = () => {
            e.deltaX > 0 ? i++ : i--;
            scrolldiv.current.scrollLeft += e.deltaX > 0 ? 1 : -1;
            if (i !== e.deltaX) {
                setTimeout(() => {
                    loop();
                }, 0.005);
            }
        };
        if (e.deltaX !== 0) loop();
    };

    const handleClick = (index) => {
        clickAudioHandler();
        setactiveThumb(index);
        triggerPage(index);
        scrolldiv.current.children[0].children[index].scrollIntoView({
            behavior: "smooth",
            block: "end",
            inline: "nearest",
        });
    };

    const handleNavigation = (dir) => {
        let obj = { deltaX: dir * 200 };
        handleSwipe(obj);
    };

    const checkoverflow = () => {
        let check = scrolldiv.current.clientWidth < scrolldiv.current.children[0].clientWidth;
        if (check) {
            setisOverflow(true);
        } else {
            setisOverflow(false);
        }
    };

    const handletogglePanel = (e, val = null) => {
        // e.preventDefault(); // Let's stop this event.
        // e.stopPropagation();
        if (val === null) {
            setshowThumbs((showThumbs) => !showThumbs);
        } else {
            setshowThumbs(val);
        }
    };

    useEffect(() => {
        if (scrolldiv && scrolldiv.current) checkoverflow();
    }, [scrolldiv]);

    useEffect(() => {
        if (scrolldiv && scrolldiv.current) checkoverflow();
    }, [windowsize]);

    useEffect(() => {
        if (activePage !== activeThumb) {
            console.log(activePage);
            setactiveThumb(activePage);
            scrolldiv.current.children[0].children[activePage].scrollIntoView({
                behavior: "smooth",
                block: "end",
                inline: "nearest",
            });
        }
    }, [activePage]);

    return (
        <React.Fragment>
            <Wrapper show={showThumbs && page==undefined} isedge={isedge}>
                {page==undefined && <Chevron
                    src={paneltogglesrc[0]}
                    showThumbs={showThumbs}
                    className="togglePanel"
                    onClick={handletogglePanel}
                ></Chevron>}
               
                {isOverflow &&  (
                    <img src={chevronsrc[0]} className="navigator left" onClick={() => handleNavigation(-1)}></img>
                )}

                <Swipeable
                    onSwiped={handleSwipe}
                    {...{
                        delta: 10,
                        preventDefaultTouchmoveEvent: false,
                        trackTouch: false,
                        trackMouse: true,
                        rotationAngle: 0,
                    }}
                >
                    <ScrollWrapper ref={scrolldiv} className="scrollWrapper">
                        <TightWrapper isOverflow={isOverflow}>
                            {thumbdata.map((thumb, index) => (
                                <Thumbnail
                                    key={index}
                                    thumb={thumb}
                                    index={index}
                                    activeThumb={activeThumb}
                                    handleClick={handleClick}
                                />
                            ))}
                        </TightWrapper>
                    </ScrollWrapper>
                </Swipeable>
                {isOverflow && (
                    <img src={chevronsrc[1]} className="navigator right" onClick={() => handleNavigation(1)}></img>
                )}
            </Wrapper>
        </React.Fragment>
    );
};

export default ThumbsWrapper;
